import { Box, Card, CardContent, IconButton, Typography } from '@mui/material';
import { Delete as DeleteIcon, DragIndicator, Edit as EditIcon } from '@mui/icons-material';
import { useSortable } from '@dnd-kit/sortable';
import { getEventCardStyle, eventCardStyles as styles } from './styles/eventCardStyles';

export default function EventCard({ event, onEdit, onDelete, isDragOverlay = false }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: event.event_id,
    data: { type: 'flow-event' },
  });
  const isPending = !!event.isPendingSchema;
  const style = getEventCardStyle({ isDragOverlay, transform, transition, isDragging });

  return (
    <Card ref={setNodeRef} style={style} sx={styles.card({ isPending, isDragOverlay })}>
      <CardContent sx={styles.content}>
        <Box sx={styles.row}>
          <Box {...listeners} {...attributes} sx={styles.dragHandle(isDragOverlay)}>
            <DragIndicator sx={styles.dragIcon} />
          </Box>
          <Box sx={styles.orderBadge(isPending)}>{event.event_order}</Box>
          <Box sx={styles.eventText}>
            <Box sx={styles.titleRow}>
              <Typography variant="subtitle1" fontWeight="medium" noWrap>
                {event.event_name}
              </Typography>
              {event.priority && (
                <Box sx={styles.priorityBadge(event.priority)}>{event.priority}</Box>
              )}
            </Box>
            {isPending ? (
              <Typography variant="body2" sx={styles.pendingLabel}>
                New from schema · 2 scenarios on save
              </Typography>
            ) : (
              <Typography variant="body2" color="text.secondary">
                {event.scenarios?.length || 0} scenario(s)
              </Typography>
            )}
          </Box>
          {!isDragOverlay && (
            <Box sx={styles.actions}>
              <IconButton
                size="small"
                aria-label="edit event"
                onClick={() => onEdit(event)}
                disabled={isPending}
                sx={styles.editButton}
              >
                <EditIcon />
              </IconButton>
              <IconButton
                size="small"
                aria-label="delete event"
                onClick={() => onDelete(event.event_id)}
                color="error"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
